<template>
    <teleport to="body">
        <transition name="backdrop">
            <div v-if="show" @click="tryClose" class="backdrop"></div>
        </transition>
        <transition name="dialog">
            <dialog open v-if="show">
                <header>
                    <slot name="header">
                        <h2>{{ title }}</h2>
                    </slot>
                </header>
                <section>
                    <p>{{ message }}</p>
                </section>
                <menu v-if="!fixed">
                    <slot name="actions">
                        <base-button @click="tryClose">Yes</base-button>
                        <base-button @click="cancel">Cancel</base-button>
                    </slot>
                </menu>
            </dialog>
        </transition>
    </teleport>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: false,
        },
        message: {
            type: String,
            required: false,
        },
        fixed: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['close', 'cancel'],
    methods: {
        tryClose() {
            if (this.fixed) {
                return;
            }
            this.$emit('close');
        },
        cancel(){
            this.$emit('cancel');
        }
    },
};
</script>

<style scoped>
.backdrop {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 10;
}

dialog {
    position: fixed;
    top: 20vh;
    left: 10%;
    width: 80%;
    z-index: 100;
    border-radius: 12px;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-color: white;
}

header {
    background-color: rgb(82, 150, 86);
    color: white;
    width: 100%;
    padding: 1rem;
}

header h2 {
    margin: 0;
}

section {
    padding: 1rem;
}

menu {
    padding: 1rem;
    display: flex;
    justify-content: flex-end;
    margin: 0;
}

@media (min-width: 768px) {
    dialog {
        left: calc(50% - 20rem);
        width: 40rem;
    }
}

.dialog-enter-from,
.dialog-leave-to {
    opacity: 0;
    transform: scale(0.8);
}

.dialog-enter-active {
    transition: all 0.3s ease-in;
}

.dialog-leave-active {
    transition: all 0.3s ease-out;
}

.dialog-enter-to,
.dialog-leave-from {
    opacity: 1;
    transform: scale(1);
}

.backdrop-enter-from,
.backdrop-leave-to {
    opacity: 0;
}

.backdrop-enter-active {
    transition: all 0.3s ease-in;
}

.backdrop-leave-active {
    transition: all 0.3s ease-out;
}

.backdrop-enter-to,
.backdrop-leave-from {
    opacity: 1;
}
</style>